import { buildDemandeService } from '../buildDemandeService'
import type { ContratProADTO, FormationDTO, LovProADTO } from '@/features/api/extranet/dto/Demande/PROA'

export default buildDemandeService<ContratProADTO, LovProADTO>({
  dispositif: 'PROA',
  normaliserData: normaliserData,
})

function normaliserData(data: ContratProADTO) {
  data.fichiers = data.fichiers ?? []

  data.employeur = data.employeur ?? ({} as any)
  data.employeur!.contact = data.employeur?.contact ?? ({} as any)
  data.employeur!.etablissement = data.employeur?.etablissement ?? ({} as any)
  data.employeur!.etablissement!.adresse = data.employeur?.etablissement?.adresse ?? ({} as any)

  data.salarie = data.salarie ?? ({} as any)
  data.salarie!.adresse = data.salarie?.adresse ?? ({} as any)
  data.salarie!.source = data.salarie?.source ?? 'Portail'

  data.tutorat = data.tutorat ?? ({} as any)
  data.tutorat!.tuteurEntrepriseEmployeur = data.tutorat?.tuteurEntrepriseEmployeur ?? ({} as any)
  data.tutorat!.tuteurEntrepriseUtilisatrice = data.tutorat?.tuteurEntrepriseUtilisatrice ?? ({} as any)

  data.contrat = data.contrat ?? ({} as any)
  data.contrat!.dureeHebdomadaire = data.contrat?.dureeHebdomadaire ?? ({} as any)
  data.formation = data.formation ?? ({} as FormationDTO)
  data.formation.modules = data.formation.modules ?? []

  /*

  data.formation.referenceFormationInterneEntreprise = data.formation.referenceFormationInterneEntreprise ?? null
  data.formation.typeQualification = data.formation.typeQualification ?? TypeQualification.Rncp
  data.formation.rncp = data.formation.rncp ?? ({} as RncpDto)
  data.formation.formacode = data.formation.formacode ?? ({} as FormacodeDTO)
  data.formation.nsf = data.formation.nsf ?? null
  data.formation.diplome = data.formation.diplome ?? null
  data.formation.dureeEnseignement = data.formation.dureeEnseignement ?? null

  */
  return data
}

